// extracted by mini-css-extract-plugin
export default {"wrapper":"OptionSelect_wrapper__b5wkD","container":"OptionSelect_container__gyEEP","option":"OptionSelect_option__F+Ryx"};